// src/pages/Exams/generate/hooks/useStyleProfile.ts
import { useQuery } from '@tanstack/react-query';
import { ExamGenApi } from '../client';

export function useStyleProfile(neId: number | null, subjectId: number | null) {
  return useQuery({
    queryKey: ['exam_gen', 'style_profile', neId, subjectId],
    queryFn: () => ExamGenApi.styleProfile(neId as number, subjectId as number),
    enabled: !!neId && !!subjectId,
    staleTime: 5 * 60 * 1000,
  });
}
